import styled from '@emotion/styled'

export const StyledMessage = styled('section')({
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    color: 'white',
    textAlign: 'center',
    height: '100%',
    border: '1px solid white',
    '& p': {
        border: '0',
        padding: '0',
        margin: '0',
        textAlign: 'center',
        color: 'white',
    },
})
